import { useEffect, useState } from "react";
import { Button, Select, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

/** Aktif sürümü dropdown'dan seçtirir. children, seçimle birlikte gönderilecek ek alanlar içindir. */
export default function ActiveVersionSelector({ versions, active, onActivate, disabled, children }) {
    const { t } = useTranslation();
    const [selected, setSelected] = useState(active);

    useEffect(() => setSelected(active), [active]);

    return (
        <Space align="end" wrap>
            <div>
                <Typography.Text type="secondary">{t('Active version')}</Typography.Text>
                <Select
                    value={versions.includes(selected) ? selected : undefined}
                    onChange={setSelected}
                    placeholder={t('Select a version')}
                    style={{ display: 'block', width: 220 }}
                    options={versions.map(version => ({
                        value: version,
                        label: version === active ? `${version} — ${t('Active')}` : `${version}`
                    }))}
                />
            </div>
            {children}
            <Button
                type="primary"
                disabled={disabled || selected === active || selected === undefined}
                onClick={() => onActivate(selected)}
            >
                {t('Activate')}
            </Button>
        </Space>
    );
}
